
export const LOAD_USER_DATA_IN_PROGRESS = "LOAD_USER_DATA_IN_PROGRESS";
export const loadUserDataInProgress = () => ({
  type: LOAD_USER_DATA_IN_PROGRESS,
});

export const LOAD_USER_DATA_SUCCESS = "LOAD_USER_DATA_SUCCESS";
export const loadUserDataSuccess = (data) => ({
  type: LOAD_USER_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_USER_DATA_FAILURE = "LOAD_USER_DATA_FAILURE";
export const loadUserDataFailure = (data) => ({
  type: LOAD_USER_DATA_FAILURE,
  payload: { data },
});

export const OPEN_USER_DIALOG = "OPEN_USER_DIALOG";
export const openUserDialog = () => ({
  type: OPEN_USER_DIALOG,
});

export const CLOSE_USER_DIALOG = "CLOSE_USER_DIALOG";
export const closeUserDialog = () => ({
  type: CLOSE_USER_DIALOG,
});

export const USER_OPERATION_COMPLETED = "USER_OPERATION_COMPLETED";
export const userOperationCompleted = () => ({
  type: USER_OPERATION_COMPLETED,
});


export const LOAD_USER_ROLE_DATA_SUCCESS = "LOAD_USER_ROLE_DATA_SUCCESS";
export const loadUserRoleDataSuccess = (data) => ({
  type: LOAD_USER_ROLE_DATA_SUCCESS,
  payload: { data },
});


export const LOAD_USER_PERMISSIONS_DATA_SUCCESS = "LOAD_USER_PERMISSIONS_DATA_SUCCESS";
export const loadUserPermissionsDataSuccess = (data) => ({
  type: LOAD_USER_PERMISSIONS_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_APP_USER_DATA_SUCCESS = "LOAD_APP_USER_DATA_SUCCESS";
export const loadAppUserDataSuccess = (data) => ({
  type: LOAD_APP_USER_DATA_SUCCESS,
  payload: { data },
});